module.exports = __webpack_public_path__ + "img/mchnt_logo.f7e3e233.svg";